<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(sheet.id ? 'Edit Safety Data Sheet: ' + sheet.id : 'New Safety Data Sheet') + ' :: MeritEHS'"/>

            <h4 class="py-2 mb-2">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link :to="`/safety-data-sheets`">
                            <i class="fa fa-files-o"></i> Safety Data Sheets
                        </router-link>
                    </li>
                    <template v-if="sheet.id">
                        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                            <router-link :to="`/safety-data-sheets/view/${sheet.id}`">
                                {{ sheet.data_sheet_name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                            <i class="fa fa-edit"></i> Edit
                        </li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                            <i class="fa fa-plus"></i> New
                        </li>
                    </template>
                    <li class="ml-3 d-none d-md-inline-block">
                        <button type="button" class="btn btn-sm btn-success" v-on:click="saveSafetyDataSheet(this)" :disabled="saving">
                            <span v-if="sheet.id">Update</span>
                            <span v-else>Create</span>
                            Safety Data Sheet
                        </button>
                    </li>
                </ol>
            </h4>

            <div class="d-block d-md-none mt-3 mb-3">
                <button type="button" class="btn btn-sm btn-success" v-on:click="saveSafetyDataSheet(this)" :disabled="saving">
                    <span v-if="sheet.id">Update</span>
                    <span v-else>Create</span>
                    Safety Data Sheet
                </button>
            </div>

            <div class="row mt-2">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card mb-3">
                        <div class="card-header">Safety Data Sheet</div>
                        <div class="card-body">

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.data_sheet_name }" class="row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.data_sheet_name}">
                                    Data Sheet Name:
                                    <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-md-8 col-sm-12">
                                    <b-form-input v-model="sheet.data_sheet_name" :class="{'is-invalid': errors.data_sheet_name}" placeholder="Enter a Safety Data Sheet Name"></b-form-input>

                                    <div v-if="errors.data_sheet_name" class="text-danger">
                                        <span v-for="error in errors.data_sheet_name">{{ error }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.manufacturer_name }" class="row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.manufacturer_name}">Manufacturer:</label>
                                <div class="col-md-8 col-sm-12">
                                    <b-form-input v-model="sheet.manufacturer_name" :class="{'is-invalid': errors.manufacturer_name}" placeholder="Enter a Manufacturer Name"></b-form-input>

                                    <div v-if="errors.manufacturer_name" class="text-danger">
                                        <span v-for="error in errors.manufacturer_name">{{ error }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.supplier_name }" class="row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.supplier_name}">Supplier:</label>
                                <div class="col-md-8 col-sm-12">
                                    <b-form-input v-model="sheet.supplier_name" :class="{'is-invalid': errors.supplier_name}" placeholder="Enter a Supplier Name"></b-form-input>

                                    <div v-if="errors.supplier_name" class="text-danger">
                                        <span v-for="error in errors.supplier_name">{{ error }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.product_code }" class="row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.product_code}">Product Code:</label>
                                <div class="col-md-8 col-sm-12">
                                    <b-form-input v-model="sheet.product_code" :class="{'is-invalid': errors.product_code}" placeholder="Enter Product Code"></b-form-input>

                                    <div v-if="errors.product_code" class="text-danger">
                                        <span v-for="error in errors.product_code">{{ error }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.cas_nbr }" class="row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.cas_nbr}">CAS#:</label>
                                <div class="col-md-8 col-sm-12">
                                    <b-form-input v-model="sheet.cas_nbr" :class="{'is-invalid': errors.cas_nbr}" placeholder="Enter CAS#"></b-form-input>

                                    <div v-if="errors.cas_nbr" class="text-danger">
                                        <span v-for="error in errors.cas_nbr">{{ error }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.is_active }" class="row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.is_active}">Active:</label>
                                <div class="col-md-8 col-sm-12">
                                    <b-form-checkbox v-model="sheet.is_active" :value="1" :unchecked-value="0" plain><span class="text-info">Inactive Sheets are Excluded from the Public SDS Library</span></b-form-checkbox>

                                    <div v-if="errors.is_active" class="text-danger">
                                        <span v-for="error in errors.is_active">{{ error }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.file }" class="row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.file}">
                                    Upload Sheet:
                                    <i class="fa fa-asterisk text-danger" v-if="!sheet.id"></i>
                                </label>
                                <div class="col-md-8 col-sm-12">
                                    <b-form-file v-model="file" :class="{'is-invalid': errors.file}" placeholder="Upload the Data Sheet"></b-form-file>

                                    <div v-if="errors.file" class="text-danger">
                                        <span v-for="error in errors.file">{{ error }}</span>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveSafetyDataSheet(this)" :disabled="saving">
                <span v-if="sheet.id">Update</span>
                <span v-else>Create</span>
                Safety Data Sheet
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                sheet: {},
                file: null,
                errors: {},
            }
        },

        computed: {

        },

        methods: {

            getSafetyDataSheet: function() {
                //Get the data
                this.$http
                    .get('/safety-data-sheets/edit' + (this.id ? '/' + this.id : ''))
                    .then(response => {
                        //Set all the data
                        this.sheet = response.data.sheet;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            saveSafetyDataSheet: function() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .postWithSingleFile('/safety-data-sheets/edit' + (this.id ? '/' + this.id : ''), this.sheet, this.file)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Safety Data Sheet Saved');

                    //Return to main list?
                    this.$router.push('/safety-data-sheets/view/' + response.data.id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            onJobSiteSelectUpdate (jobsite) {
              //Check for null
                if(jobsite == null)
                {
                    //Stop
                    this.sheet.JobsiteId = null;
                    return;
                }

                //Send the value
                this.sheet.JobsiteId = jobsite.JobsiteId;
                //this.sheet.JobsiteName = jobsite.JobsiteName;
                //this.sheet.JobsiteNumber = jobsite.JobsiteNumber;
            },

            onUserSelectUpdate (user)
            {
                //Check for null
                if(user == null)
                {
                    this.sheet.UserId = null
                    return;
                }

                //Set it
                this.sheet.UserId = user.UserId;
            },

            datePickerChanged ( data ) {
                // Stringify datePicked
                var dateParts = data.target.value.split("/");
                this.sheet.sheet_date = dateParts[2]+'-'+dateParts[0]+'-'+dateParts[1];
            },

            safetyMemberEmployee(employee){
                //Setters
                this.new_safety_member.employee = employee;
                this.new_safety_member.craft = employee.TitleName || employee.position;
                this.new_safety_member.company = this.$store.state.user.account_name;
                this.new_safety_member.member_type = 'Employee';

                //Add it
                this.addSafetyCommitteeMemberAlt();

                //Reset
                this.$refs.newMemberEmployee.clearInput();

                //Without this, it won't re-render the input names
                //this.$forceUpdate();
            },

            safetyMemberUser(user){
                //Setters
                this.new_safety_member.user = user;
                this.new_safety_member.craft = user.title;
                this.new_safety_member.company = this.$store.state.user.account_name;
                this.new_safety_member.member_type = 'User';

                //Add it
                this.addSafetyCommitteeMemberAlt();

                //Reset the input
                this.$refs.newMemberUser.reset();

                //Without this, it won't re-render the input names
                //this.$forceUpdate();
            },

            addSafetyCommitteeMemberAlt(){
                //Validation
                if(!this.new_safety_member.member_type)
                {
                    this.$toastr.error('Member Type is Required');
                    return;
                }

                //Validation
                if(this.new_safety_member.member_type == 'Employee' && !this.new_safety_member.employee)
                {
                    this.$toastr.error('Employee is Required');
                    return;
                }

                //Validation
                if(this.new_safety_member.member_type == 'User' && !this.new_safety_member.user)
                {
                    this.$toastr.error('User is Required');
                    return;
                }

                //If null, set to array
                if(this.sheet.sheet_attendees == null)
                {
                    this.sheet.sheet_attendees = [];
                }

                //We need to make sure the Employee or User doesn't already exist.
                for(var i in this.sheet.sheet_attendees)
                {
                    //Check it
                    if(this.new_safety_member.employee && this.new_safety_member.employee.EmployeeId == this.sheet.sheet_attendees[i].EmployeeId)
                    {
                        //Exists, stop here
                        this.$toastr.error('Employee Already Added');
                        return;
                    }

                    //Check it
                    if(this.new_safety_member.user && this.new_safety_member.user.UserId == this.sheet.sheet_attendees[i].UserId)
                    {
                        //Exists, stop here
                        this.$toastr.error('User Already Added');
                        return;;
                    }
                }

                //Build the member
                var member = {
                    type: this.new_safety_member.member_type,
                };

                //Switch
                switch(this.new_safety_member.member_type)
                {
                    case 'Employee':
                        member.EmployeeId = this.new_safety_member.employee.EmployeeId;
                        member.name = this.new_safety_member.employee.FirstName + ' ' + this.new_safety_member.employee.LastName;
                        member.EmployeeNumber = this.new_safety_member.employee.EmployeeNumber;
                        break;
                    case 'User':
                        member.UserId = this.new_safety_member.user.UserId;
                        member.name = this.new_safety_member.user.FirstName + ' ' + this.new_safety_member.user.LastName;
                        member.email = this.new_safety_member.user.email;
                        break;
                }

                //Reset
                this.sheet.sheet_attendees.push(member);
                this.new_safety_member = {
                    member_type: null,
                };
            },

            removeAttendee(type, id){
                //Loop
                for(var i in this.sheet.sheet_attendees)
                {
                    //Check type and id
                    if(type == this.sheet.sheet_attendees[i].type &&
                        (id == this.sheet.sheet_attendees[i].UserId || id == this.sheet.sheet_attendees[i].EmployeeId))
                    {
                        this.sheet.sheet_attendees.splice(i, 1);
                    }
                }
            }
        },

        mounted() {
            //Get the Safety Data Sheet
            this.getSafetyDataSheet();
        }
    }
</script>
